import React from "react";

const FooterSection = () => {
  return (
    <footer className="fw-section fw-footer">
      <div className="fw-footer-inner">
        <div className="fw-footer-brand">kazhavda.mk</div>
        <div className="fw-footer-copy">
          © {new Date().getFullYear()} Pokana која остава впечаток.
        </div>
      </div>
    </footer>
  );
};

export default FooterSection;

